import React, { Component } from 'react'
import Button from '@ui/Button'
import RowItem from '@ui/RowItem'
import cn from 'classnames'

export default class ButtonsRow extends Component {
  render() {
    const { id, buttons, selected, editable, onSelect, inactive, onRemove, mode } =
      this.props

    return (
      <RowItem id={id} editable={editable} onRemove={onRemove}>
        <div className={cn('buttons-in-row grow width full', mode)}>
          {buttons.map(button => (
            <Button
              key={button.id}
              id={button.value}
              onClick={onSelect}
              primary={button.value === selected}
              content={button.text}
              value={button.value}
              inactive={inactive}
              size='big'
            />
          ))}
        </div>
      </RowItem>
    )
  }
}
